import RotatingWord from "./RotatingWord";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

type Props = { wordIndex?: number };

export default function Hero({ wordIndex }: Props) {
  return (
    <Box
      sx={{
        textAlign: { xs: "center", md: "left" },
        fontSize: { xs: 42, sm: 68, md: 86 },
      }}
    >
      <Typography
        variant="h3"
        component="h1"
        sx={{
          fontWeight: 600,
          mb: 1,
          fontFamily: "var(--font-headline)",
          fontSize: "inherit",
          lineHeight: 1.15,
        }}
      >
        Un cântecel unic pentru
      </Typography>
      <Typography
        variant="h2"
        component="h2"
        sx={{
          fontWeight: 600,

          // lock height on larger screens to allow up to two lines and avoid layout jump
          height: "2.4em",

          lineHeight: 1.15,
          fontSize: "inherit",
          overflow: "hidden",

          // allow wrapping between words, but LetterReveal prevents breaking inside words
          whiteSpace: { xs: "normal", md: "normal" },

          display: "block",
          textAlign: "center",
          width: "100%"
        }}>
        <Box sx={{ display: "flex", justifyContent: "center", zIndex: -1 }}>
          <RotatingWord externalIndex={wordIndex} />
        </Box>
      </Typography>
    </Box>
  );
}
